export default {
  title: 'Ret tilgængelighed',
  amend_availabilities_form: {
    date: {
      label: 'Vælg en dato',
    },
    times: {
      label: 'Vagter og åbningstider',
      description:
        'Definer dine åbningstider for den valgte dato. Gør dine vagter længere eller kortere, eller bloker dem. Mindst én vagt skal være åben.',
      breakfast: {
        label: 'Morgenmad',
      },
      lunch: {
        label: 'Frokost',
      },
      dinner: {
        label: 'Aftensmad',
      },
    },
  },
  reason: {
    label: 'Tilføj en årsag (valgfrit)',
    placeholder: 'Indtast beskrivelse...',
  },
  buttons: {
    save: 'Gem',
  },
  projects: {
    online_shop: 'Onlineshop',
    reservations: 'Reservationer',
    storefront: 'Storefront',
  },
  error_messages: {
    creation_failed: 'Undtagelsen kunne ikke oprettes',
  },
};
